import styled from "styled-components";
import { makeStyles } from "@material-ui/core";
import { theme } from "@themes";

export const FrameContainer = styled.div`
  width: 100%;
  height: 296px;
  flex-shrink: 0;
`;

export const BlockLabel = styled.div`
  width: 193px;
  height: 32px;
  flex-shrink: 0;
`;
export const InsideLable = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const BlockOne = styled.div`
  width: 100%;
  height: 13em;
  max-width: 33.3333%;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    border-radius: 8px;
    width: 100%;
    object-fit: cover;
  }

  &::before {
    border-radius: 8px;
    content: "";
    position: absolute;
    top: 10;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(
      123,
      61,
      153,
      0.7
    ); /* Adjust the color and opacity as needed */
  }
  .usericon {
    width: 138px;
    height: 84px;
    flex-shrink: 0;
    fill: ${({ theme }) => theme.neutral.white};
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .buttonlayout {
    display: flex;
    margin-left: -45px;
    width: 237px;
    height: 26px;
    padding: 11px 32px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.neutral.white};
  }
  .button {
    color: ${({ theme }) => theme.neutral.white};
    text-align: center;
    font-family: "Noto Sans", Helvetica;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .engagement-default {
    max-width: 33.3333%;
    width: 100%;
    img {
      object-fit: cover;
      width: 100%;
      object-position: top;
    }
  }
`;

export const BlockTwo = styled.div`
  width: 377px;
  height: 216px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.text.disabled};
  padding: 10px;
  margin-right: 20px;
  background: ${({ theme }) => theme.neutral.white};
  position: relative;

  .img {
    width: 152px;
    height: 216px;
    flex-shrink: 0;
    border-radius: 8px 0 0 8px;
    position: relative;
    margin-top: -11px;
    margin-left: -10px;
  }

  .boxtext {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 188px;
    height: 174px;
  }
  .datalayout {
    width: 167px;
    height: 81px;
    flex-shrink: 0;
  }
`;

export const BoxLabel = styled.div`
  display: flex;
  width: 133px;
  height: 25px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  .label {
    color: ${({ theme }) => theme.primary.purple};
    font-family: "Noto Sans", Helvetica;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.24px;
  }
`;
export const Text = styled.div`
  display: block;

  .label1,
  .label2,
  .label3,
  .label4 {
    display: block;
    color: ${({ theme }) => theme.primary.purple};
    font-family: "Noto Sans", Helvetica;
    font-style: normal;
    line-height: normal;
    margin-bottom: 5px;
  }

  .label1 {
    font-size: 14px;
    font-weight: 600;
  }

  .label2 {
    font-size: 12px;
    font-weight: 400;
  }

  .label3 {
    font-size: 14px;
    font-weight: 600;
  }

  .label4 {
    font-size: 12px;
    font-weight: 400;
  }
`;

export const Svgimgae = styled.div`
  width: 138px;
  height: 84px;
  flex-shrink: 0;
  fill: ${({ theme }) => theme.neutral.white};
`;

// export const Label=styled.div`
// color: ${({ theme }) => theme.primary.purple};
// leading-trim: both;
// text-edge: cap;
// font-family: "Noto Sans", Helvetica;
// font-size: 24px;
// font-style: normal;
// font-weight: 700;
// line-height: normal;

// `;
export const Label = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  svg {
    width: 18px;
    height: 28px;
  }
  image {
    width: 400px;
    height: 216px;
    flex-shrink: 0;
    border-radius: 8px;
    background: rgba(53, 4, 77, 0.7);
  }
`;
export const LabelText = styled.div`
  text-align: left;
  color: ${(props) => (props.black ? "black" : theme.tabs.selected)};
  leading-trim: both;
  text-edge: cap;
  left: 16px;
  font-family: "Noto Sans-Bold", Helvetica;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-items: center;

  a {
    text-decoration: none;
    color: ${(props) => (props.black ? "black" : theme.tabs.selected)};
  }
  .MuiSvgIcon-root {
    font-size: 16px;
    margin-left: 15px;
  }
`;

export const Arrow = styled.div`
  width: 32px;
  height: 32px;
`;
export const ButtonView = styled.div`
  width: 40px;
  height: 19px;
  flex-shrink: 0;
  fill: var(--a-00095, ${({ theme }) => theme.primary.purple});
  .button {
    color: ${({ theme }) => theme.background.light};
    text-align: center;
    font-family: "Noto Sans", Helvetica;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
  }
`;
export const Button = styled.div`
  color: ${({ theme }) => theme.background.light};
  text-align: center;
  font-family: "Noto Sans", Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const GeneralMySpaces = styled.div`
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(223, 223, 223, 0.3);
`;

export const ContentHeaderMySpace = styled.div`
  display: inline-flex;
  align-items: center;
  width: 98%;
`;

export const TitleMySpace = styled.p`
  font-size: 20px;
  color: ${({ theme }) => theme.neutral.gray[2600]};
  font-weight: 700;
  width: 20%;
`;

export const ContentFilters = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1em 0;
  width: 100%;
`;

export const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 7vw 4fr 1fr;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 11vw 4fr 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 11vw 4fr 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr 1fr;
  }
  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .table-action {
    margin-right: 20px;
  }
`;

export const ContentFilterButton = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  border-radius: 1px;
  background: ${({ theme }) => theme.neutral.white};
  width: 6em;
  height: 4em;
  margin: 0.5em 0px 0px 0px;
  align-items: center;
  display: flex;
  justify-content: center;
  .filter-list-icon {
    color: ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
  &:hover {
    cursor: pointer;
    border-top: 1px solid
      ${({ iconColor, theme }) => (iconColor ? theme.tabs.selected : theme.text.primary)};
  }
`;

export const useStyles = makeStyles(() => ({
  contentForMySpaces: {
    backgroundColor: theme.neutral.white,
    margin: "1.5em",
  },
}));
